<template>
    <div class="w-100">
       <div class="row justify-content-center align-items-center w-100 scrollbarStep m-0">
          <div class="col-md-9 upload-section">
             <div class="whiteBG p-md-3 Step-Form my-4 upload-section">
                <div class="captail_wrap registrationSteps position-relative fullLoader p-0 w-100">
                   <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader">
                   </complete-loading>
                   <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''">
                   </message-component>
                   <div class="alert alert-danger d-flex align-items-center justify-content-between" role="alert"
                      v-if="noCamera">
                      {{ $t("step5_browsersupport") }}
                      <feather type="x" @click.prevent="noCamera = false">
                      </feather>
                   </div>
                   <div class="alert alert-danger d-flex align-items-center justify-content-between" role="alert"
                      v-if="cameraNotAllow">
                      {{ $t("step5_cameradenied") }}
                      <feather type="x" @click.prevent="cameraNotAllow = false"></feather>
                   </div>
                   <div class="middle_section m-0">
                      <div class="d-flex justify-content-center motAroow"
                         v-if="continueMobileOption && !mobileScreen">
                         <section class="stepsForm-include valigncenter border-0 max-1440 mx-auto w-100">
                            <div class="row justify-content-center w-100 mx-0">
                               <div class="col-12 mobPad text-center">
                                  <h3 class="incMob mb-left">{{ $t("step5_scanqrcode") }}</h3>
                                  <p>{{ $t("step5_scanqrmobile") }}</p>
                                  <div class="scanInfo d-flex align-items-center text-left mt-4">
                                     <vue-qrcode :value="$env_var.qrCodeLink + get_user.token" />
                                     <p>
                                        <feather size="16px" type="alert-triangle"></feather>
                                        {{ $t("step5_keepageopen") }}
                                     </p>
                                  </div>
                                  <a class="clooseIT-circle cap_btn red px-4 large_btn mt-4" href="#"
                                     @click.prevent=" ContinueMobileBrowser(false); stepInfo();">{{ $t("step5_continueBrowser") }}</a>
                               </div>
                            </div>
                         </section>
                      </div>
                      <div class="motAroow" v-else-if="mobileScreen && parseInt(get_user.step) == 6">
                         <section class="stepsForm-include valigncenter border-0 max-1440 mx-auto w-100">
                            <div class="row justify-content-center w-100 mx-0">
                               <div class="col-12 col-lg-6 mobPad text-center p-2">
                                  <div class="sorImh">
                                     <p>{{ $t("step5_docSubsuccess") }}</p>
                                     <a href="" @click.prevent="redirect()"
                                        class="common_btn btn_sm review-status">{{ $t("step5_reviewstatus") }}</a>
                                  </div>
                               </div>
                            </div>
                         </section>
                      </div> 
                      <div class="abSxt" v-else>
                         <div class="mid_scroll_content d-flex justify-content-center">
                            <section class="stepsForm-include valigncenter border-0 max-1440 mx-auto w-100">
                               <div class="row justify-content-center w-100 mx-0">
                                  <div class="col-12 mobPad p-0">
                                     <form data-toggle="validator" method="post" enctype="multipart/form-data"
                                        id="individualForm" v-on:submit.prevent="submitIndividual()">
                                        <div class="row justify-content-center mx-0 w-100 mobleft-text">
                                           <div class="col-12 text-center p-0"
                                              v-if="showTab == index && (index == 0 || index == 1)"
                                              v-for="(value, key, index) in documentsByName">
                                              <div class="d-flex justify-content-center my-3">
                                                 <div class="col-md-9">
                                                    <h3 class="text-center incMob mb-left mtmOb mb-2"
                                                       v-if="index == 0">{{ $t("step5_identifyDoc") }}</h3>
                                                    <h3 class="text-center incMob mb-left mtmOb mb-2"
                                                       v-if="index == 1">{{ $t("step5_proofresidence") }}</h3>
                                                    <p class="mb-left mtmOb" v-if="index == 0">
                                                       {{ $t("step5_uploadphototext") }}
                                                    </p>
                                                    <p class="mb-left mtmOb" v-if="index == 1">
                                                       {{ $t("step5_uploadproof") }}
                                                    </p>
                                                 </div>
                                              </div>
                                              <div class="proofIdenty text-left">
                                                 <div
                                                    class="identiyUL row no-gutters justify-content-center">
                                                    <div class="col-md-10">
                                                       <div class="row no-gutters">
                                                          <div class="col-12 px-2"
                                                             v-for="(val, key1) in fileNames[key]"
                                                             :class="tabEnableDisable(key, key1)">
                                                             <div class="whiteBG regulate text-center"
                                                                @click.prevent=" clearData(key, key1); fileName = key1;"
                                                                :class="[{ active: key1 == fileName },]">
                                                                <div class="iconModify"><img
                                                                   :src="'../../../../static/fxView/images/' + doc_ico[key1] + '.svg'"
                                                                   alt="Icon" /></div>
                                                                <p>{{ val }}</p>
                                                             </div>
                                                          </div>
                                                       </div>
                                                    </div>
                                                 </div>
                                                 <div class="px-md-4">
                                                    <div class="customTabs-acc whiteBG d-none p-4 border-radius-10 mt-2 mx-0 active"
                                                       v-if="fileName != '' && double_allow.includes(fileName)">
                                                       <div class="row m-0 no-gutters">
                                                          <div class="col-12 mt-1">
                                                             <div class="flotil db2">
                                                                <span class="moduleMob"> 
                                                                   <h5 class="mb-2"
                                                                      v-if="fileName == 'Drivers_License'">
                                                                      {{ $t("step5_takephoto") }}
                                                                   </h5>
                                                                   <h5 class="mb-2"
                                                                      v-if="fileName == 'Government_Issued_Photo_ID'">
                                                                      {{ $t("step5_takegovernid") }}
                                                                   </h5>
                                                                   <p class="f-14 mb-1">
                                                                      <strong>{{ $t("step5_goodQuality") }}</strong>{{ $t("step5_brightclear") }}
                                                                   </p>
                                                                   <p class="f-14">
                                                                      <strong>{{ $t("step5_note") }} </strong> {{ $t("step5_allcorner") }}
                                                                   </p>
                                                                </span>
                                                                <div
                                                                   class="findidentity row mt-4 no-gutters">
                                                                   <div class="col-12 col-md-4 pr-2">
                                                                      <div class="cornerInc">
                                                                         <span
                                                                            class="boxColred whiteBG good hideMobile">
                                                                         <img src="../../../../static/fxView/images/group-5.svg"
                                                                            alt="Icon" />
                                                                         </span>
                                                                      </div>
                                                                   </div>
                                                                   <div class="col-12 col-md-4 px-2">
                                                                      <div class="cornerInc">
                                                                         <span
                                                                            class="boxColred whiteBG bad mid hideMobile">
                                                                         <img class="wrong"
                                                                            src="../../../../static/fxView/images/group-7.svg"
                                                                            alt="Icon" />
                                                                         <img src="../../../../static/fxView/images/crossSv.svg"
                                                                            alt="Icon"
                                                                            class="crossSV" />
                                                                         </span>
                                                                      </div>
                                                                   </div>
                                                                   <div class="col-12 col-md-4 pl-2">
                                                                      <div class="cornerInc">
                                                                         <span
                                                                            class="boxColred whiteBG bad small hideMobile">
                                                                         <img class="wrong"
                                                                            src="../../../../static/fxView/images/group-7.svg"
                                                                            alt="Icon" />
                                                                         <img src="../../../../static/fxView/images/crossSv.svg"
                                                                            alt="Icon"
                                                                            class="crossSV" />
                                                                         </span>
                                                                      </div>
                                                                   </div>
                                                                </div>
                                                             </div>
                                                          </div>
                                                          <div class="col-12 mt-4">
                                                             <div class="row no-gutters mob-mx-0 upladIdent">
                                                                <div class="col-12 col-lg-6 pr-2">
                                                                   <div
                                                                      class="upload-btn-wrapper border-0 idenCopy-upload w-100 d-flex w-100">
                                                                      <div class="h-100 d-flex justify-content-center w-100"
                                                                         v-if="documentJsonData[key] != undefined && documentNameSHowFuncUnderTab(key, 'FRONT')">
                                                                         <div class="showResult"
                                                                            v-for="val in documentJsonData[key]"
                                                                            v-if="val.document_name.includes('FRONT')">
                                                                            <a class=""
                                                                               :href="$env_var.docsLink + get_user.profile.user_id + '&doc=' + val.name"
                                                                               target="_blank()">
                                                                            <iframe
                                                                               height="50px"
                                                                               v-if="val.name.split('.')[val.name.split('.').length - 1].toLowerCase() == 'pdf'"
                                                                               :src="$env_var.docsLink + get_user.profile.user_id + '&doc=' + val.name"></iframe>
                                                                            <img height="50px"
                                                                               v-else
                                                                               :src="$env_var.docsLink + get_user.profile.user_id + '&doc=' + val.name" />
                                                                            </a>
                                                                            <a class="customClose"
                                                                               href="#">
                                                                               <feather
                                                                                  type="trash-2"
                                                                                   :class="pageLoader ? 'disabled' : ''"
                                                                                  v-on:click.stop.prevent=" deleteFunc(key, val.id)">
                                                                               </feather>
                                                                            </a>
                                                                         </div>
                                                                      </div>
                                                                      <div v-else class="full-height-row">
                                                                         <div class="inbit"
                                                                            v-if="check_img(value.data, 'front', fileName)"
                                                                            :class="documentenabledisable(key, 'FRONT', fileName)">
                                                                            <div
                                                                               class="btn outerWrapper py-0 px-2 w-100 text-center">
                                                                               <div
                                                                                  class="d-flex align-items-center justify-content-between trP p-3 flex-column">
                                                                                  <h4>{{ $t(
                                                                                     "step5_uploadfrontside"
                                                                                     ) }}
                                                                                  </h4>
                                                                                  <button
                                                                                     @click.stop.prevent=""
                                                                                     onclick="document.getElementById('front').click()"
                                                                                     class="btn d-inline-flex align-items-center">
                                                                                     <feather
                                                                                        size="14px"
                                                                                        type="plus-circle"
                                                                                        class="mr-2">
                                                                                     </feather>
                                                                                     {{ $t("step5_upload") }}
                                                                                  </button>
                                                                               </div>
                                                                               <p class="mxSixe">
                                                                                  {{ $t("step5_maxfilesize") }}{{ $env_var.fileSize
                                                                                  .individualSize }}{{ $env_var.fileSize.type }}
                                                                               </p>
                                                                            </div>
                                                                            <input type="file"
                                                                               name="myfile"
                                                                               id="front"
                                                                               @change=" addMoreFileChange($event.target.files[0], key, 'front')" />
                                                                         </div>
                                                                         <div class="showResult"
                                                                            v-for="( val, ind ) in value.data"
                                                                            v-if="value.data.length > 0 && val.type == 'front' && val.fileName == fileName">
                                                                            <iframe
                                                                               v-if="val.name != '' && val.file.type == 'application/pdf'"
                                                                               :src="addfileImage(val.file)"></iframe>
                                                                            <img :src="addfileImage(val.file)"
                                                                               alt="Icon" />
                                                                            <a class="customClose"
                                                                               href="#">
                                                                               <feather size="18px"
                                                                                  type="x"
                                                                                  @click.prevent=" clearFileAddMore(key, ind)">
                                                                               </feather>
                                                                            </a>
                                                                         </div>
                                                                      </div>
                                                                   </div>
                                                                </div>
                                                                <div class="col-12 col-lg-6 pl-2">
                                                                   <div
                                                                      class="upload-btn-wrapper idenCopy-upload w-100 border-0 d-flex flex-wrap w-100">
                                                                      <div class="h-100 d-flex justify-content-center w-100"
                                                                         v-if="documentJsonData[key] != undefined && documentNameSHowFuncUnderTab(key, 'BACK')">
                                                                         <div class="showResult"
                                                                            v-for="val in documentJsonData[key]"
                                                                            v-if="val.document_name.includes('BACK')">
                                                                            <a class=""
                                                                               :href="$env_var.docsLink + get_user.profile.user_id + '&doc=' + val.name"
                                                                               target="_blank()">
                                                                            <iframe
                                                                               height="50px"
                                                                               v-if="val.name.split('.')[val.name.split('.').length - 1].toLowerCase() == 'pdf'"
                                                                               :src="$env_var.docsLink + get_user.profile.user_id + '&doc=' + val.name"></iframe>
                                                                            <img height="50px"
                                                                               v-else
                                                                               :src="$env_var.docsLink + get_user.profile.user_id + '&doc=' + val.name" />
                                                                            </a>
                                                                            <a class="customClose"
                                                                               href="#">
                                                                               <feather
                                                                                  type="trash-2"
                                                                                  :class="pageLoader ? 'disabled' : ''"
                                                                                  v-on:click.stop.prevent=" deleteFunc(key, val.id)">
                                                                               </feather>
                                                                            </a>
                                                                         </div>
                                                                      </div>
                                                                      <div v-else class="full-height-row">
                                                                         <div class="inbit"
                                                                            v-if="check_img(value.data, 'back', fileName)"
                                                                            :class="documentenabledisable(key, 'BACK', fileName)">
                                                                            <div
                                                                               class="btn outerWrapper py-0 px-2 w-100 text-center">
                                                                               <div
                                                                                  class="d-flex align-items-center justify-content-between trP p-3 flex-column">
                                                                                  <h4>{{ $t(
                                                                                     "step5_uploadbackside"
                                                                                     ) }}
                                                                                  </h4>
                                                                                  <button
                                                                                     @click.stop.prevent=""
                                                                                     onclick="document.getElementById('back').click()"
                                                                                     class="btn d-inline-flex align-items-center">
                                                                                     <feather
                                                                                        size="14px"
                                                                                        type="plus-circle"
                                                                                        class="mr-2">
                                                                                     </feather>
                                                                                     {{ $t("step5_upload") }}
                                                                                  </button>
                                                                               </div>
                                                                               <p class="mxSixe">
                                                                                  {{ $t("step5_maxfilesize") }}{{ $env_var.fileSize
                                                                                  .individualSize }}{{ $env_var.fileSize.type }}
                                                                               </p>
                                                                            </div>
                                                                            <input type="file"
                                                                               name="myfile"
                                                                               id="back"
                                                                               @change=" addMoreFileChange($event.target.files[0], key, 'back')" />
                                                                         </div>
                                                                         <div class="showResult"
                                                                            v-for="( val, ind ) in value.data"
                                                                            v-if="value.data.length > 0 && val.type == 'back' && val.fileName == fileName">
                                                                            <iframe
                                                                               v-if="val.name != '' && val.file.type == 'application/pdf'"
                                                                               :src="addfileImage(val.file)"></iframe>
                                                                            <img :src="addfileImage(val.file)"
                                                                               alt="Icon" />
                                                                            <a class="customClose"
                                                                               href="#">
                                                                               <feather size="18px"
                                                                                  type="x"
                                                                                  @click.prevent=" clearFileAddMore(key, ind)">
                                                                               </feather>
                                                                            </a>
                                                                         </div>
                                                                      </div>
                                                                   </div>
                                                                </div>
                                                             </div>
                                                             <div class="mt-3 d-flex justify-content-center align-items-center"
                                                                v-if="(documentJsonData[key] != undefined && documentJsonData[key].length < 2 && index == 0) || (documentJsonData[key] == undefined && index == 0)">
                                                                <div class="col-12 col-md-6 p-0">
                                                                   <input type="text" name="idnumber"
                                                                      v-model="idnumber"
                                                                      placeholder="Please Enter ID Number"
                                                                      class="idNumber"
                                                                      v-validate="'required'"
                                                                      ref="idnumberInput" />

                                                                   <p class="text-danger red d-block mb-0 error-Show pt-1"
y                                                                      v-for="error in errors.collect('idnumber')">
                                                                      {{ $t("step5_idenfNumber") }}
                                                                   </p>
                                                                </div>
                                                             </div>
                                                          </div>
                                                       </div>
                                                    </div>
                                                    <div class="customTabs-acc whiteBG d-none p-4 border-radius-10 mt-2 mx-0 active"
                                                       v-if="fileName != '' && !double_allow.includes(fileName)">
                                                       <div class="row m-0 no-gutters">
                                                          <div class="col-12 p-0 mt-1">
                                                             <div class="flotil db2" v-if="index == 0">
                                                                <span class="moduleMob">
                                                                   <h5 class="mb-2"
                                                                      v-if="fileName == 'Passport'">
                                                                      {{ $t("step5_uploadpassport") }}
                                                                   </h5>
                                                                   <h5 class="mb-2"
                                                                      v-if="fileName == 'Drivers_License'">
                                                                      {{ $t("step5_photolicense") }}
                                                                   </h5>
                                                                   <h5 class="mb-2"
                                                                      v-if="fileName == 'Government_Issued_Photo_ID'">
                                                                      {{ $t("step5_photogovernmentID") }}
                                                                   </h5>
                                                                   <p class="f-14 mb-1">
                                                                      <strong>{{ $t("step5_goodQuality") }}</strong>{{ $t("step5_brightclear") }}
                                                                   </p>
                                                                   <p class="f-14">
                                                                      <strong>{{ $t("step5_note") }} </strong> {{ $t("step5_allcorner") }}
                                                                   </p>
                                                                </span>
                                                                <div
                                                                   class="findidentity row mt-4 no-gutters justify-content-center">
                                                                   <div class="col-12 col-md-4 pr-2">
                                                                      <div class="cornerInc">
                                                                         <span
                                                                            class="boxColred whiteBG good hideMobile">
                                                                         <img src="../../../../static/fxView/images/group-5.svg"
                                                                            alt="Icon" />
                                                                         </span>
                                                                      </div>
                                                                   </div>
                                                                   <div class="col-12 col-md-4 px-2">
                                                                      <div class="cornerInc">
                                                                         <span
                                                                            class="boxColred whiteBG bad mid hideMobile">
                                                                         <img class="wrong"
                                                                            src="../../../../static/fxView/images/group-7.svg"
                                                                            alt="Icon" />
                                                                         <img src="../../../../static/fxView/images/crossSv.svg"
                                                                            alt="Icon"
                                                                            class="crossSV" />
                                                                         </span>
                                                                      </div>
                                                                   </div>
                                                                   <div class="col-12 col-md-4 pl-2">
                                                                      <div class="cornerInc">
                                                                         <span
                                                                            class="boxColred whiteBG bad small hideMobile">
                                                                         <img class="wrong"
                                                                            src="../../../../static/fxView/images/group-7.svg"
                                                                            alt="Icon" />
                                                                         <img src="../../../../static/fxView/images/crossSv.svg"
                                                                            alt="Icon"
                                                                            class="crossSV" />
                                                                         </span>
                                                                      </div>
                                                                   </div>
                                                                </div>
                                                             </div>
                                                             <div class="flotil" v-if="index == 1">
                                                                <span class="moduleMob">
                                                                   <h5 class="mb-1">
                                                                      {{ $t("step5_proofsixold") }}
                                                                   </h5>
                                                                   <p>{{ $t("step5_bankstatement") }}</p>
                                                                </span>
                                                                <div class="findidentity row mt-12">
                                                                   <div class="col-12 col-md-12">
                                                                      <div
                                                                         class="cornerInc documentCenter">
                                                                         <span
                                                                            class="boxColred good">
                                                                         <img src="../../../../static/fxView/images/bankDoc.svg"
                                                                            alt="Icon"
                                                                            v-if="fileName == 'Bank_Credit_Card_Statement'" />
                                                                         <img src="../../../../static/fxView/images/utility.svg"
                                                                            alt="Icon"
                                                                            v-if="fileName == 'Utility_Bill'" />
                                                                         <img src="../../../../static/fxView/images/payroll.svg"
                                                                            alt="Icon"
                                                                            v-if="fileName == 'Payroll_Statement'" />
                                                                         <img src="../../../../static/fxView/images/taxDoc.svg"
                                                                            alt="Icon"
                                                                            v-if="fileName == 'Tax_Document'" />
                                                                         </span>
                                                                      </div>
                                                                      <p class="f-14">
                                                                         <strong>{{ $t("step5_note") }} </strong> {{ $t("step5_allcorner1") }}
                                                                      </p>
                                                                   </div>
                                                                </div>
                                                             </div>
                                                          </div>
                                                          <div class="col-12 p-0 mt-4">
                                                             <div
                                                                class="row mob-mx-0 justify-content-center">
                                                                <div class="col-12 col-lg-6 p-0">
                                                                   <div
                                                                      class="upload-btn-wrapper idenCopy-upload w-100 border-0">
                                                                      <div class="h-100 px-2 w-100"
                                                                         v-if="documentJsonData[key] != undefined && documentNameSHowFuncUnderTab(key, 'single')">
                                                                         <div class="showResult"
                                                                            v-for="val in documentJsonData[key]">
                                                                            <a class=""
                                                                               :href="$env_var.docsLink + get_user.profile.user_id + '&doc=' + val.name"
                                                                               target="_blank()">
                                                                            <iframe
                                                                               height="50px"
                                                                               v-if="val.name.split('.')[val.name.split('.').length - 1].toLowerCase() == 'pdf'"
                                                                               :src="$env_var.docsLink + get_user.profile.user_id + '&doc=' + val.name"></iframe>
                                                                            <img height="50px"
                                                                               v-else
                                                                               :src="$env_var.docsLink + get_user.profile.user_id + '&doc=' + val.name" />
                                                                            </a>
                                                                            <a class="customClose"
                                                                               href="#">
                                                                               <feather
                                                                                  type="trash-2"
                                                                                  :class="pageLoader ? 'disabled' : ''"
                                                                                  v-on:click.stop.prevent=" deleteFunc(key, val.id)">
                                                                               </feather>
                                                                            </a>
                                                                         </div>
                                                                      </div>
                                                                      <div class="h-100 p-2 w-100"
                                                                         v-else>
                                                                         <div class="showResult uploadPDF"
                                                                            v-for="( val, ind ) in value.data"
                                                                            v-if="value.data.length > 0 && val.fileName == fileName">
                                                                            <iframe
                                                                               v-if="val.name != '' && val.file.type == 'application/pdf'"
                                                                               :src="addfileImage(val.file)"></iframe>
                                                                            <img v-else-if="val.name != ''"
                                                                               :src="addfileImage(val.file)"
                                                                               alt="Icon" />
                                                                            <a class="customClose"
                                                                               href="#">
                                                                               <feather size="18px"
                                                                                  type="x"
                                                                                  @click.prevent=" clearFileAddMore(key, ind)">
                                                                               </feather>
                                                                            </a>
                                                                         </div>
                                                                         <div class="inbit h-100"
                                                                            :class="documentenabledisable(key, '', fileName)"
                                                                            v-if="value.data.length == 0">
                                                                            <div
                                                                               class="btn outerWrapper py-0 px-2 w-100 text-center">
                                                                               <div
                                                                                  class="d-flex align-items-center justify-content-between trP p-3 flex-column">
                                                                                  <h4>{{ $t(
                                                                                     "step5_uploadyourDoc"
                                                                                     ) }}
                                                                                  </h4>
                                                                                  <button
                                                                                     class="btn d-inline-flex align-items-center">
                                                                                     <feather
                                                                                        size="14px"
                                                                                        type="plus-circle"
                                                                                        class="mr-2">
                                                                                     </feather>
                                                                                     {{ $t("step5_upload") }}
                                                                                  </button>
                                                                               </div>
                                                                               <p class="mxSixe">
                                                                                  {{ $t("step5_maxfilesize") }}{{ $env_var.fileSize
                                                                                  .individualSize }}{{ $env_var.fileSize.type }}
                                                                               </p>
                                                                            </div>
                                                                            <input type="file"
                                                                               name="document[]"
                                                                               :id="key" :ref="key"
                                                                               @change=" addMoreFileChange($event.target.files[0], key, key)" />
                                                                         </div>
                                                                      </div>
                                                                   </div>
                                                                </div>
                                                             </div>
                                                             <div class="mt-3 d-flex justify-content-center align-items-center"
                                                                v-if="documentJsonData[key] == undefined && index == 0">
                                                                <div class="col-12 col-md-6 p-0">
                                                                   <input type="text" name="idnumber"
                                                                      v-model="idnumber"
                                                                      placeholder="Please Enter ID Number"
                                                                      class="idNumber"
                                                                      v-validate="'required'"
                                                                      :ref="'idnumberInput'" />
                                                                   <p class="red d-block mb-0 error-Show pt-2"
                                                                      v-for="error in errors.collect('idnumber')">
                                                                      {{ $t("step5_idenfNumber") }}
                                                                   </p>
                                                                </div>
                                                             </div>
                                                          </div>
                                                       </div>
                                                    </div>
                                                 </div>
                                              </div>
                                              <div class="loopUpload mt-4 px-4" v-show="fileName != ''">
                                                 <div class="alert alert-danger d-flex align-items-center justify-content-between"
                                                    role="alert" v-if="totalSizeErrMsg">
                                                    {{ $t("step5_filesizemax") }}{{ $env_var.fileSize.totalSize }}{{ $env_var.fileSize.type }}
                                                    <feather type="x"
                                                       @click.prevent="totalSizeErrMsg = false"> </feather>
                                                 </div>
                                                 <div class="alert alert-danger d-flex align-items-center justify-content-between"
                                                    role="alert" v-if="individualSizeErrMsg">
                                                    {{ $t("step5_filesizemax") }}{{ $env_var.fileSize.individualSize }}{{ $env_var.fileSize.type }}
                                                    <feather type="x"
                                                       @click.prevent=" individualSizeErrMsg = false">
                                                    </feather>
                                                 </div>
                                                 <div class="alert alert-danger d-flex align-items-center justify-content-between"
                                                    role="alert" v-if="extensionType">
                                                    {{ $t("step5_filesallowed") }}
                                                    <feather type="x"
                                                       @click.prevent="extensionType = false"> </feather>
                                                 </div>
                                              </div>
                                              <div class="alert alert-danger d-flex align-items-center justify-content-between"
                                                 role="alert" v-if="docValidation">
                                                 <p
                                                    v-if="fileName == 'Drivers_License' || fileName == 'Government_Issued_Photo_ID'">
                                                    {{ $t("step5_uploadbothside") }}
                                                 </p>
                                                 <p v-else>{{ $t("step5_verifydoc") }}.</p>
                                                 <feather type="x" @click.prevent="docValidation = false">
                                                 </feather>
                                              </div>
                                              <div
                                                 class="d-flex justify-content-center align-items-center mt-4 pb-4 flex-wrap">
                                                 <div class="mr-3">
                                                    <input type="button"
                                                       class="backButton prism_btn btn_sm darkBG"
                                                       value="Back" v-if="index != 0"
                                                       :class="pageLoader ? 'disabled' : ''"
                                                       @click.prevent.stop="backButton()" />
                                                 </div>
                                                 <!-- <div class="contact_withPhone mr-3" v-if="!mobileScreen">
                                                    <a class="d-flex align-items-center" href="#" @click.prevent="continueMobileOption=true">
                                                        <feather size="18px" type="smartphone"> </feather> <span>{{$t("step5_continuemobile")}}</span>
                                                    </a>
                                                    </div> -->
                                                 <div class="submitButton text-center mobRotate m-0">
                                                    <input type="submit" class="prism_btn btn_sm mb-0"
                                                       :value="index == 0 ? 'Next' : 'Submit'"
                                                       :class="pageLoader ? 'disabled' : ''" />
                                                 </div>
                                              </div>
                                           </div>
                                           <div v-if="parseInt(showTab) == 2">
                                              <div class="alert alert-danger d-flex align-items-center justify-content-between"
                                                 role="alert" v-if="docValidation">
                                                 {{ $t("step5_recentphoto") }}
                                                 <feather type="x"
                                                    @click.prevent="docValidation = false"></feather>
                                              </div>
                                              <div class="card w-100 webcam">
                                                 <div class="card-header bg-transparent">
                                                    <h4 class="card-title m-0">{{ $t("step5_photoverif") }}
                                                    </h4>
                                                 </div>
                                                 <div class="card-body pt-4 pb-4 pl-3 pr-3" id="idensic">
                                                    <div class="row mx-0 mt-3">
                                                       <div class="col-12 col-lg-6 mobPad">
                                                          <p class="pb-3">{{ $t("step5_legitimacy") }}</p>
                                                       </div>
                                                       <div class="col-lg-6 mobPad col-12 uploadProof-row p-3 d-flex justify-content-between align-items-center"
                                                          v-if="documentJsonData['Photo_Verification'] != undefined">
                                                          <div class="attachmenttSatus-proof"
                                                             v-for="val in documentJsonData['Photo_Verification']">
                                                             <a class="UploadedProof"
                                                                :href="$env_var.docsLink + get_user.profile.user_id + '&doc=' + val.name"
                                                                target="_blank()">
                                                             <iframe height="50px"
                                                                v-if="val.name.split('.')[val.name.split('.').length - 1].toLowerCase() == 'pdf'"
                                                                :src="$env_var.docsLink + get_user.profile.user_id + '&doc=' + val.name"></iframe>
                                                             <img height="50px" v-else
                                                                :src="$env_var.docsLink + get_user.profile.user_id + '&doc=' + val.name" />
                                                             </a>
                                                             <a class="delete blue" href="#"
                                                                :class="pageLoader ? 'disabled' : ''"
                                                                v-on:click.stop.prevent=" deleteFunc('Photo_Verification', val.id)">
                                                                <feather type="trash-2"></feather>
                                                             </a>
                                                          </div>
                                                          <div class="bckButton"><button
                                                             class="cap_btn blue px-4"
                                                             @click.prevent.stop="showTab = 0">{{ $t("step5_back") }}</button>
                                                          </div>
                                                       </div>
                                                       <div class="mobPad col-lg-6 col-12 pl-md-5 text-center"
                                                          v-else>
                                                          <div class="file-uploader custmSelfie"
                                                             v-if="upload_options">
                                                             <img class="selfiIcon"
                                                                src="../../../../static/fxView/images/2968338.svg"
                                                                alt="FxView Svg" />
                                                             <span class="cap_btn darkBG px-4 large_btn"
                                                                @click.prevent=" openCam(); upload_options = false;"
                                                                v-html="!mobileScreen ? $t('step5_start') : $t('step5_TakeSelfie')"></span>
                                                             <span class="noWebcam mt-2 d-block"
                                                                v-if="!mobileScreen">{{ $t("rp_or") }}</span>
                                                             <div class="contact_withPhone d-flex align-items-center justify-content-center"
                                                                v-if="!mobileScreen">
                                                                <a class="noWebcam d-flex align-items-center justify-content-center"
                                                                   @click.prevent=" continueMobileOption = true">
                                                                   <feather size="18px"
                                                                      type="smartphone"></feather>
                                                                   <span>{{ $t("step5_webcamdont") }}</span>
                                                                </a>
                                                             </div>
                                                          </div>
                                                          <div class="file-uploader webCapture"
                                                             v-show="isCameraOpen && !file_upload">
                                                             <div class="uploadArea mx-auto">
                                                                <div v-show="!isLoading"
                                                                   class="camera-box afterCLick mb-4"
                                                                   :class="{ flash: isShotPhoto }">
                                                                   <div class="camera-shutter"
                                                                      :class="{ flash: isShotPhoto }">
                                                                   </div>
                                                                   <video v-show="!isPhotoTaken"
                                                                      ref="camera" height="200px"
                                                                      width="200px" autoplay></video>
                                                                   <canvas v-show="isPhotoTaken"
                                                                      id="photoTaken" ref="canvas"
                                                                      height="380px"
                                                                      width="400px"></canvas>
                                                                   <div class="timercon"
                                                                      v-if="timer > 0">{{ timer }}</div>
                                                                </div>
                                                                <div v-if="isLoading"
                                                                   class="camera-box openCamera mb-4">
                                                                   <div class="timercon">loading...
                                                                   </div>
                                                                </div>
                                                                <input type="hidden" id="canvasimg"
                                                                   name="canvasimg" />
                                                                <div v-if="!isPhotoTaken && !isLoading && timer == 0"
                                                                   class="camera-shoot mb-3">
                                                                   <span
                                                                      class="cap_btn darkBG px-4 large_btn"
                                                                      @click.prevent="countDown()">{{ $t("step5_captureimage") }}</span>
                                                                </div>
                                                                <span class="cursor mt-3"
                                                                   @click.prevent="closeCam()"
                                                                   v-if="!isPhotoTaken">{{ $t("step5_cancel") }}</span>
                                                             </div>
                                                          </div>
                                                          <div v-if="file_upload">
                                                             <div class="alert alert-danger d-flex align-items-center justify-content-between"
                                                                role="alert"
                                                                v-if="individualSizeErrMsg">
                                                                {{ $t("step5_filemax") }}{{ $env_var.fileSize.individualSize }}{{ $env_var.fileSize.type }}
                                                                <feather type="x"
                                                                   @click.prevent=" individualSizeErrMsg = false">
                                                                </feather>
                                                             </div>
                                                             <div
                                                                class="file-uploader loopUpload position-relative ste6">
                                                                <label for="ipv_document"
                                                                   class="form_label">{{ $t("step5_choosefileupload") }}</label>
                                                                <input type="file" id="ipv_document"
                                                                   class="file-upload"
                                                                   name="document[]"
                                                                   ref="Photo_Verification"
                                                                   @change=" onFileChange('Photo_Verification', $event.target.files[0])" />
                                                                <div v-if="documentsByName.Photo_Verification.data[0].name != ''"
                                                                   class="attachmenttSatus">
                                                                   <iframe
                                                                      v-if="documentsByName.Photo_Verification.data[0].name != '' && documentsByName.Photo_Verification.data[0].file.type == 'application/pdf'"
                                                                      :src="addfileImage(documentsByName.Photo_Verification.data[0].file)"></iframe>
                                                                   <img v-else-if="documentsByName.Photo_Verification.data[0].name != ''"
                                                                      :src="addfileImage(documentsByName.Photo_Verification.data[0].file)" />
                                                                   <span class="deletedoc">
                                                                      <feather type="x"
                                                                         @click.prevent=" documentsByName.Photo_Verification.data[0].name = ''">
                                                                      </feather>
                                                                   </span>
                                                                </div>
                                                                <p>{{ $t("step5_allowmaxsize") }}{{ $env_var.fileSize.totalSize }}{{ $env_var.fileSize.type }}
                                                                </p>
                                                             </div>
                                                             <div>or</div>
                                                             <span
                                                                class="cap_btn greenBG d-inline-block mt-2 large_btn"
                                                                @click.prevent=" file_upload = false; upload_options = true; documentsByName.Photo_Verification.data[0].name = '';">
                                                             {{ $t("step5_useWebcam") }}
                                                             </span>
                                                          </div>
                                                          <div class="verfiyITV mt-3" v-if="isPhotoTaken">
                                                             <input type="submit"
                                                                class="cap_btn darkBG px-4 large_btn greenBG"
                                                                :class="pageLoader ? 'disabled' : ''"
                                                                value="Submit" name="" required="" />
                                                             <button
                                                                class="cap_btn darkBG px-4 large_btn mobcapBTN darkBG"
                                                                @click.prevent.stop="closeCam()">{{ $t("step5_cancel") }}</button>
                                                          </div>
                                                       </div>
                                                    </div>
                                                 </div>
                                              </div>
                                           </div>
                                        </div>
                                     </form>
                                  </div>
                               </div>
                            </section>
                         </div>
                      </div>
                   </div>
                </div>
             </div>
          </div>
       </div>
    </div>
 </template>
 <script>
    import * as types from "@/types";
    import { mapActions } from "vuex";
    import VueQrcode from "vue-qrcode";
    import ipv_component from "./ipv_component";
    import { fxViewMixins } from "@/plugins/fxView";
    export default {
        name: "step-six",
        mixins: [fxViewMixins],
        data() {
            return {
                response_msg: "",
                msg_type: "",
                pageLoader: false,
                continueMobileOption: false,
                notification_msg: "",
                notification_type: "",
                submitted: false,
                doc_array: [],
                identity_document: "",
                govt_document2: "",
                govt_document3: "",
                brand_file_request: "",
                showTab: 0,
    
                upload_options: true,
                file_upload: false,
    
                setUpFxaccount: false,
                isCameraOpen: false,
                isPhotoTaken: false,
                isShotPhoto: false,
                isLoading: false,
                file4: "",
                timer: 0,
                idnumber: "",
                fileNames: {
                    Proof_of_Identity: {
                        Passport: "Passport",
                        Drivers_License: "Drivers License",
                        Government_Issued_Photo_ID: "Government Issued Photo ID",
                    },
                    Proof_of_Residence: {
                        Bank_Credit_Card_Statement: "Bank Statement/Credit Card Statement",
                        Utility_Bill: "Utility Bill",
                        Payroll_Statement: "Payroll Statement",
                        Tax_Document: "Tax Document",
                    },
                },
                doc_ico: {
                    Passport: "Group-3",
                    Drivers_License: "Group-2",
                    Government_Issued_Photo_ID: "Group-4",
                    Bank_Credit_Card_Statement: "Group-3",
                    Utility_Bill: "Group-2",
                    Payroll_Statement: "Group-4",
                    Tax_Document: "Group-4",
                },
                double_allow: ["Drivers_License", "Government_Issued_Photo_ID"],
                fileName: "Passport",
                documentJsonData: {},
                documentsByName: {
                    Proof_of_Identity: { description: "", data: [] },
                    Proof_of_Residence: { description: "", data: [] },
                    Photo_Verification: { description: "", data: [] },
                },
                lengthErrMsg: false,
                totalSizeErrMsg: false,
                individualSizeErrMsg: false,
                noCamera: false,
                cameraNotAllow: false,
                docValidation: false,
                otp: "",
                username: "",
                chngedelFun: false,
                extensionAllw: ["jpg", "jpeg", "png", "pdf"],
                extensionType: false,
                id_type: "",
                disable: false,
                mobileScreen: false,
                userCountry: "N/A",
            };
        },
        components: {
            IpvComponent: ipv_component,
            VueQrcode,
        },
        methods: {
            ...mapActions({
                _runRegisterStepFive: types.RUN_REGISTER_STEP5,
                _runDelDoc: types.RUN_DELETE_DOC,
                // _runSkipDocumentUpload: types.RUN_SKIP_DOCUMENT_UPLOAD,
                _runGetSumSubResp: types.RUN_GET_SUM_SUB_RESPONSE,
                _runGetUserIp: types.RUN_GET_USER_IP,
                // _runGetResolveDocIssue: types.RUN_RESOLVE_DOC_ISSUE
            }),
            clearData(key, key1) {
                if (this.fileName != key1) {
                    this.documentsByName[key].data = [];
                }
                this.idnumber = "";
                this.docValidation = false;
            },
            tierFunc() {
                if (parseInt(this.get_user.step) == 5) {
                    this.$router.replace({
                        name: "fxView.support",
                        params: { tabName: "openRequest", page: "view_dash" },
                    });
                }
            },
            tabEnableDisable(key, key1) {
                let fileName1 = key1;
                if (key1.includes("_")) {
                    fileName1 = key1.split("_")[0];
                }
                let data = Object.keys(this.fileNames[key]).length == 3 ? "col-md-4" : "col-md-3";
    
                if (Object.keys(this.documentJsonData).length > 0) {
                    if (this.documentJsonData[key] && this.documentJsonData[key] !== "undefined") {
                        if (this.documentJsonData[key][0].document_name.includes(fileName1)) {
                            this.fileName = key1;
                            return "enable " + data;
                        } else {
                            return "disable " + data;
                        }
                    } else {
                        return "enable " + data;
                    }
                } else {
                    return "enable " + data;
                }
            },
            documentNameSHowFuncUnderTab(key, getdocType) {
                let fileName1 = this.fileName;
                if (getdocType == "single") {
                    if (this.fileName.includes("_")) {
                        fileName1 = this.fileName.split("_")[0];
                    }
                    if (this.documentJsonData[key].length == 1) {
                        if (this.documentJsonData[key][0].document_name.includes(fileName1)) {
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return false;
                    }
                } else if (getdocType == "BACK") {
                    if (this.fileName.includes("_")) {
                        fileName1 = this.fileName.split("_")[0];
                    }
                    if (this.documentJsonData[key].length == 1) {
                        if (this.documentJsonData[key][0].document_name.includes(fileName1) && this.documentJsonData[key][0].document_name.includes(getdocType)) {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (this.documentJsonData[key].length == 2) {
                        let i = "";
                        if (this.documentJsonData[key][0].document_name.includes(fileName1) && this.documentJsonData[key][0].document_name.includes(getdocType)) {
                            i = 1;
                        }
                        if (this.documentJsonData[key][1].document_name.includes(fileName1) && this.documentJsonData[key][1].document_name.includes(getdocType)) {
                            i = 1;
                        }
    
                        if (i == 1) {
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return false;
                    }
                } else if (getdocType == "FRONT") {
                    if (this.fileName.includes("_")) {
                        fileName1 = this.fileName.split("_")[0];
                    }
                    if (this.documentJsonData[key].length == 1) {
                        if (this.documentJsonData[key][0].document_name.includes(fileName1) && this.documentJsonData[key][0].document_name.includes(getdocType)) {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (this.documentJsonData[key].length == 2) {
                        let i = "";
                        if (this.documentJsonData[key][0].document_name.includes(fileName1) && this.documentJsonData[key][0].document_name.includes(getdocType)) {
                            i = 1;
                        }
                        if (this.documentJsonData[key][1].document_name.includes(fileName1) && this.documentJsonData[key][1].document_name.includes(getdocType)) {
                            i = 1;
                        }
    
                        if (i == 1) {
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return false;
                    }
                }
            },
            documentenabledisable(key, getType, getFileName) {
                let fileName1 = getFileName;
                if (getFileName.includes("_")) {
                    fileName1 = getFileName.split("_")[0];
                }
                if (this.documentJsonData[key] && this.documentJsonData[key] !== "undefined") {
                    if (Object.keys(this.documentJsonData[key]).length == 0) {
                        return "enable";
                    } else if (Object.keys(this.documentJsonData[key]).length == 1) {
                        if (
                            (this.documentJsonData[key][0].document_name.includes("FRONT") || this.documentJsonData[key][0].document_name.includes("BACK")) &&
                            getType != "" &&
                            this.documentJsonData[key][0].document_name.includes(fileName1)
                        ) {
                            if (this.documentJsonData[key][0].document_name.includes("FRONT") && getType == "FRONT") {
                                return "disable";
                            } else if (this.documentJsonData[key][0].document_name.includes("BACK") && getType == "BACK") {
                                return "disable";
                            } else {
                                return "enable";
                            }
                        } else {
                            return "disable";
                        }
                    } else if (Object.keys(this.documentJsonData[key]).length > 1) {
                        return "disable";
                    }
                } else {
                    return "enable";
                }
            },
            addfileImage(file) {
                return URL.createObjectURL(file);
            },
            clearFileAddMore(docType, index) {
                this.documentsByName[docType].data.splice(index, 1);
                this.lengthErrMsg = false;
                this.totalSizeErrMsg = false;
                this.individualSizeErrMsg = false;
            },
            check_img(data, type, fileName) {
                // console.log(data,type,fileName)
                return (
                    data.filter((val) => {
                        return val.type == type && val.fileName == fileName;
                    }).length == 0
                );
            },
            addMoreFileChange(file, docType, type) {
                this.docValidation = false;
                this.extensionType = false;
                let length = this.documentsByName[docType].data.length;
                length += this.documentJsonData[docType] != undefined ? this.documentJsonData[docType].length : 0;
                if (length == 5) {
                    this.lengthErrMsg = true;
                } else if (file.size / this.$env_var.fileSize.conversion > this.$env_var.fileSize.individualSize) {
                    this.individualSizeErrMsg = true;
    
                    document.getElementById(type).value = "";
                } else if (this.extensionAllw.indexOf(file.name.split(".")[file.name.split(".").length - 1].toLowerCase()) == -1) {
                    this.extensionType = true;
                } else {
                    this.individualSizeErrMsg = false;
                    this.lengthErrMsg = false;
                    if (type) {
                        // console.log('type',type)
                        this.documentsByName[docType].data.push({
                            file: file,
                            name: file.name,
                            fileName: this.fileName,
                            type: type,
                        });
                        document.getElementById(type).value = "";
                    } else {
                        // console.log('type not found',type)
                        this.documentsByName[docType].data.push({
                            file: file,
                            name: file.name,
                            fileName: this.fileName,
                        });
                        this.fileName = "";
                    }
                }
                // document.getElementById(docType).value = ''
            },
            clearOld() {
                let docType = Object.keys(this.documentsByName)[this.showTab];
                this.documentsByName[docType].data = [];
            },
            deleteFunc(getData1, docId) {
                if (this.pageLoader) {
                    return;
                }
                let input_json = {
                    globalParams: {
                        id: docId,
                    },
                    localParams: { parameter: this, getData: getData1 },
                };
                this._runDelDoc(input_json);
            },
            onFileChange(fieldName, file) {
                this.noCamera = false;
                this.cameraNotAllow = false;
                this.fileName = "";
                if (file.size / this.$env_var.fileSize.conversion > this.$env_var.fileSize.individualSize) {
                    this.individualSizeErrMsg = true;
                    this.refs.ipv_document.value = "";
                } else if (fieldName == "Photo_Verification") {
                    this.documentsByName["Photo_Verification"].data.push({
                        name: "",
                        file: "",
                    });
                    this.documentsByName["Photo_Verification"].data[0].name = file.name;
                    this.documentsByName["Photo_Verification"].data[0].file = file;
                    this.documentsByName["Photo_Verification"].data[0].fileName = "Photo_Verification";
                }
            },
            backButton() {
                this.showTab -= 1;
                this.fileNameChange();
                this.docValidation = false;
            },
            fileNameChange() {
                if (this.showTab != 2) {
                    this.fileName = Object.keys(this.fileNames[Object.keys(this.fileNames)[this.showTab]])[0];
                } else {
                    this.fileName = "";
                }
            },
            submitIndividual() {
                if (this.pageLoader) {
                    return;
                }
                const _that = this;
                _that.submitted = true;
                let formRequest = document.getElementById("individualForm");
                let form_name = new FormData();
                let fileSize = 0;
                let docType = Object.keys(this.documentsByName)[this.showTab];
    
                let haveFiles = 0;
                let filelength = this.documentsByName[docType].data.filter((val) => val.name).length;
                filelength += this.documentJsonData[docType] != undefined ? this.documentJsonData[docType].length : 0;
    
                this.documentsByName[docType].data.forEach((item) => {
                    if (item.name != "") {
                        if (item.type && (item.fileName == "Drivers_License" || item.fileName == "Government_Issued_Photo_ID")) {
                            form_name.append("document[]", item.file, item.fileName + "_" + item.type.toUpperCase() + "." + item.name.split(".")[item.name.split(".").length - 1]);
                        } else {
                            form_name.append("document[]", item.file, item.fileName + "." + item.name.split(".")[item.name.split(".").length - 1]);
                        }
    
                        if (item.fileName == "Passport") {
                            _that.id_type = 0;
                        } else if (item.fileName == "Drivers_License") {
                            _that.id_type = 1;
                        } else if (item.fileName == "Government_Issued_Photo_ID") {
                            _that.id_type = 2;
                        }
                        haveFiles += 1;
                        fileSize += item.file.size;
                    }
                });
                this.$validator.validate().then((valid) => {
                    if (valid) {
                        if (filelength < 2 && (_that.fileName == "Drivers_License" || _that.fileName == "Government_Issued_Photo_ID")) {
                            _that.docValidation = true;
                        } else if (filelength == 0 && (_that.fileName != "Drivers_License" || _that.fileName != "Government_Issued_Photo_ID")) {
                            _that.docValidation = true;
                        } else if (haveFiles > 0) {
                            if (fileSize / 1048576 > 60) {
                                _that.totalSizeErrMsg = true;
                                _that.$notify({
                                    group: "foo",
                                    type: "error",
                                    text: "files size should be lesser then 60 MB",
                                    duration: 10000,
                                    closeOnClick: true,
                                });
                            } else {
                                _that.totalSizeErrMsg = false;
                                _that.individualSizeErrMsg = false;
                                form_name.append("idnumber", _that.idnumber);
                                form_name.append("id_type", _that.id_type);
                                form_name.append("documenttype", docType);
                                form_name.append("ip_country", this.userCountry);
                                let input_json = {
                                    globalParams: {
                                        form: form_name,
                                    },
                                    localParams: { parameter: _that, type: "form", fromStep: 5.1 },
                                };
                                if (_that.showTab == 1) {
                                    input_json.localParams.step = "5";
                                    form_name.append("step", "5");
                                }
                                _that._runRegisterStepFive(input_json);
                            }
                        } else {
                            if (_that.showTab == 1) {
                                /******* Uncomment to test for step 2  *******/
                                form_name.append("idnumber", _that.idnumber);
                                form_name.append("id_type", _that.id_type);
                                form_name.append("documenttype", docType);
                                form_name.append("ip_country", this.userCountry);
                                let input_json = {
                                    globalParams: {
                                        form: form_name,
                                    },
                                    localParams: { parameter: _that, type: "form", fromStep: 5.1 },
                                };
                                input_json.localParams.step = "5";
                                form_name.append("step", "5");
                                _that._runRegisterStepFive(input_json);
                                /******* end *******/
                            } else {
                                _that.showTab += 1;
                                _that.fileNameChange();
                            }
                        }
                    } else {
                        _that.handleValidationErrorAdvanced(_that.errors);
                    }
                });
                this.stopCameraStream();
            },
            ...mapActions({
                _runstateLoad: types.RUN_STATE_LOAD,
            }),
            stepInfo(deleteOnLoad) {
                this._runGetUserRegisterationStepData({
                    globalParams: {},
                    localParams: {
                        parameter: this,
                        step: "5.1",
                        deleteOnLoad: deleteOnLoad ? deleteOnLoad : false,
                    },
                });
            },
            ContinueMobileBrowser(getData) {
                this.continueMobileOption = getData;
                this._runstateLoad({
                    globalParams: {},
                    localParams: { parameter: this, page: "individual_doc_step" },
                });
            },
            //================================ipv photo selfie not in use =======================================
            openCam() {
                this.isCameraOpen = true;
                this.docValidation = false;
                this.createCameraElement();
            },
            closeCam() {
                this.isCameraOpen = false;
                this.isPhotoTaken = false;
                this.isShotPhoto = false;
                this.upload_options = true;
                this.stopCameraStream();
                this.documentsByName.Photo_Verification.data[0].name = "";
                this.documentsByName.Photo_Verification.data[0].file = "";
                this.documentsByName.Photo_Verification.data[0].fileName = "";
            },
            createCameraElement() {
                this.noCamera = false;
                this.cameraNotAllow = false;
                this.isLoading = true;
                this.timer = 0;
                let _that = this;
                const constraints = (window.constraints = {
                    audio: false,
                    video: true,
                });
                navigator.mediaDevices
                    .getUserMedia(constraints)
                    .then((stream) => {
                        this.isLoading = false;
                        try {
                            this.$refs.camera.srcObject = stream;
                        } catch (error) { }
                    })
                    .catch((error) => {
                        this.isLoading = false;
                        this.isCameraOpen = false;
                        this.upload_options = true;
                        //this.file_upload = true;
                        if (error.toString().includes("Permission denied")) {
                            this.cameraNotAllow = true;
                        } else {
                            this.noCamera = true;
                        }
                        this.continueMobileOption = true;
                    });
            },
            stopCameraStream() {
                try {
                    let tracks = this.$refs.camera.srcObject.getTracks();
                    tracks.forEach((track) => {
                        track.stop();
                    });
                } catch (error) { }
            },
            countDown() {
                var timeleft = 5;
                var _that = this;
                var downloadTimer = setInterval(function () {
                    if (timeleft <= 0) {
                        clearInterval(downloadTimer);
                        _that.takePhoto();
                    }
                    _that.timer = timeleft;
                    timeleft -= 1;
                }, 1000);
            },
            takePhoto() {
                if (!this.isPhotoTaken) {
                    this.isShotPhoto = true;
    
                    const FLASH_TIMEOUT = 50;
    
                    setTimeout(() => {
                        this.isShotPhoto = false;
                    }, FLASH_TIMEOUT);
                }
                if (this.documentsByName["Photo_Verification"].data.length == 0) {
                    this.documentsByName["Photo_Verification"].data.push({
                        name: "",
                        file: "",
                    });
                }
                this.isPhotoTaken = !this.isPhotoTaken;
                const context = this.$refs.canvas.getContext("2d");
                context.drawImage(this.$refs.camera, 0, 0, 400, 400);
    
                let _that = this;
                const canvas = document.getElementById("photoTaken");
                try {
                    canvas.toBlob(function (blob) {
                        _that.documentsByName["Photo_Verification"].data[0]["name"] = "Photo_Verification.png";
                        _that.documentsByName["Photo_Verification"].data[0]["file"] = blob;
                        _that.documentsByName["Photo_Verification"].data[0]["fileName"] = "Photo_Verification";
                        // _that.file4 = blob;
                    });
                } catch (e) {
                    //console.log(e);
                    var blob = $("#photoTaken").imageBlob().blob();
                    _that.documentsByName["Photo_Verification"].data[0]["name"] = "Photo_Verification.png";
                    _that.documentsByName["Photo_Verification"].data[0]["file"] = blob;
                    _that.documentsByName["Photo_Verification"].data[0]["fileName"] = "Photo_Verification";
                }
            },
            clientKycEvent(){
               this.$trackEvent('CP+Client+Verification+11+KYC+Passed');
            },
        },
        created() {
            this.stepInfo(false);
            this._runGetUserIp({ globalParams: {}, localParams: { parameter: this } });
            this.documentsByName["Photo_Verification"].data.push({
                name: "",
                file: "",
            });
        },
        mounted() {
            const _that = this;
            jQuery(document).ready(function ($) {
                var alterClass = function () {
                    var ww = document.body.clientWidth;
                    if (ww < 767) {
                        _that.mobileScreen = true;
                    } else {
                        _that.mobileScreen = false;
                    }
                };
                $(window).resize(function () {
                    alterClass();
                });
                alterClass();
            });
        },
    };
 </script>
 <style>
    .regulate {
    /*-webkit-box-shadow: 0px 2px 20px rgb(0 0 0 / 10%);
    box-shadow: 0px 2px 20px rgb(0 0 0 / 10%);*/
    padding: 10px;
    height: 100%;
    border-radius: 10px;
    cursor: pointer;
    position: relative;
    border: 1px solid var(--bordercolor);
    }
    .regulate p {
    margin: 0;
    min-height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    line-height: 1.2;
    color: var(--theme-color);
    padding: 7px 0;
    }
    .iconModify img {
    height: 36px;
    margin-top: 8px;
    }
    .findidentity img {
    width: 180px;
    }
    .findidentity {
    justify-content: space-evenly;
    text-align: center;
    }
    span.quality {
    text-align: center;
    }
    .idenCopy-upload p.mxSixe {
    font-weight: normal;
    font-size: 11px;
    margin: 20px 0 10px 0;
    word-break: break-all;
    width: 100%;
    white-space: normal;
    }
    .d-none.active {
    display: block !important;
    }
    .idenCopy-upload .btn {
    border-width: 1px;
    }
    .idenCopy-upload .btn button.btn {
    padding: 6px 20px;
    border-radius: 4px;
    }
    .boxColred img {
    width: 150px;
    }
    .cornerInc {
    width: 100%;
    }
    .boxColred {
    padding: 10px;
    border-radius: 5px;
    border: 1px solid var(--bordercolor);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    min-height: 120px;
    overflow: hidden;
    position: relative;
    width: 100%;
    height: 120px;
    }
    span.boxColred.good {
    border-color: var(--green);
    background: none;
    }
    span.boxColred.bad {
    border-color: var(--red);
    background: none;
    }
    .boxColred img.crossSV {
    width: 35px;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    }
    span.boxColred.bad.small img.wrong {
    width: 90px;
    /*position: absolute;
    left: 10px;
    top: 10px;*/
    }
    span.boxColred.bad.mid img.wrong {
    position: relative;
    /*left: 20px;
    top: -10px;
    width: 160px;*/
    opacity: 0.5;
    }
    .boxShadow {
    box-shadow: 0px 2px 20px rgb(0 0 0 / 6%);
    }
    .border-radius-10 {
    border-radius: 10px;
    }
    .idenCopy-upload .showResult {
    border: 1px solid var(--bordercolor);
    border-radius: 10px;
    padding: 10px 0;
    position: relative;
    width: 100%;
    justify-content: space-between;
    display: flex;
    align-items: center;
    padding: 20px;
    }
    /*.idenCopy-upload .showResult .customClose {
    display: none;
    }*/
    /*.idenCopy-upload .showResult:hover .customClose {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgb(0 0 0 / 29%);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    }*/
    .idenCopy-upload .showResult .customClose svg.feather {
    background: var(--red);
    color: var(--white);
    width: 50px;
    height: 50px;
    padding: 0 13px;
    border-radius: 50%;
    }
    .showResult img {
    /*max-width: 150px;
    margin: 0 auto;
    display: block;*/
    object-fit: contain;
    height: 80px;
    max-width: 210px;
    }
    span.moduleMob {
    position: relative;
    display: block;
    }
    .identiyUL .col-12 {
    margin-bottom: 26px;
    }
    .regulate.active:before {
    position: absolute;
    content: "";
    background-repeat: no-repeat;
    width: 25px;
    height: 25px;
    top: -4px;
    right: -10px;
    z-index: 99;
    }
    .regulate.active:after {
    position: absolute;
    content: "";
    border: 1px solid var(--theme-color);
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    border-radius: 10px;
    }
    .uploadRegt {
    background: var(--lightgray1);
    padding: 15px;
    border-radius: 6px;
    margin-bottom: 30px;
    }
    .altrModal {
    position: absolute;
    left: 0;
    right: 0;
    top: 10px;
    }
    .switchButton .cap_btn {
    min-height: 40px;
    }
    .modPic img {
    max-width: 340px;
    margin: 0 auto 40px;
    display: block;
    }
    .api-accesss-tocken label.getToken {
    margin: 11px 0 8px 0;
    }
    .cap_btn.min-42 {
    min-height: 42px;
    align-items: center;
    display: flex;
    justify-content: center;
    }
    .resendMail.restPp .successPaas {
    max-width: 300px;
    width: 100%;
    }
    .switchButton {
    position: relative;
    }
    .upload-btn-wrapper .disable,
    .uploadProof-row.disable,
    .identiyUL .disable {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
    position: relative;
    }
    .upload-btn-wrapper .disable:before,
    .uploadProof-row.disable:before,
    .identiyUL .disable .regulate:before {
    position: absolute;
    content: "";
    background: rgb(0 0 0 / 17%);
    width: 100%;
    height: 100%;
    z-index: 999;
    cursor: not-allowed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    }
    .lt-aler-message {
    min-height: 80px;
    }
    .lt-aler-message .tempLateMessage {
    position: absolute !important;
    left: 0;
    right: 0;
    top: 0;
    }
    .lt-aler-message .tempLateMessage p {
    margin: 0;
    border-radius: 5px 5px 0 0;
    font-size: 14px;
    }
    .webCapture span.cursor {
    padding: 8px 20px;
    background: var(--red);
    border-radius: 4px;
    color: var(--white);
    }
    .personalInfo .customRadioButton.customRadioButton.sequare .checkmark {
    border-radius: 3px;
    }
    .mx-datepicker.form-control.datepicker input.mx-input {
    border: 0;
    height: 32px;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-weight: 300;
    font-size: 14px;
    }
    .registrationSteps .mx-datepicker.form-control.datepicker input.mx-input {
    height: 38px;
    }
    .mx-datepicker.form-control.datepicker {
    padding: 0;
    }
    .fr-view li {
    font-size: 14px;
    font-family: var(--regular);
    color: var(--textcolor);
    line-height: 24px;
    padding-bottom: 5px;
    }
    .contact_withPhone {
    /*position: absolute;
    top: 0px;
    right: 0px;*/
    z-index: 99;
    }
    input.idNumber {
    width: 100%;
    padding: 10px 15px;
    border-radius: 5px;
    color: var(--black);
    }
    .regulate.active {
    border-color: var(--green);
    background: var(--light-green);
    }
    .file-uploader {
    position: relative;
    margin-bottom: 10px;
    /*max-height: 200px;*/
    }
    .uploadArea {
    width: 200px;
    margin: 0px auto;
    }
    .form_label {
    display: block;
    color: var(--theme-color);
    font-weight: bold;
    letter-spacing: 0px;
    font-size: 18px;
    padding-bottom: 5px;
    }
    input[id="ipv_document"] {
    display: none;
    }
    label[for="ipv_document"] {
    background: #dfdedb;
    min-height: 120px;
    background-image: url("/static/fxView/images/126477.svg");
    background-repeat: no-repeat;
    background-position: top 50px center;
    position: relative;
    background-size: 7%;
    color: transparent;
    margin: auto;
    width: 100%;
    top: 0;
    left: 0;
    right: 0;
    transform: translateY(0%);
    box-sizing: border-box;
    border-radius: 5px;
    margin-bottom: 8px;
    }
    label[for="ipv_document"]:before {
    content: "Select File";
    display: block;
    position: absolute;
    top: 55%;
    transform: translateY(-40%);
    font-size: 14px;
    font-weight: 400;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    color: var(--theme-color);
    }
    label[for="ipv_document"].changed,
    label[for="ipv_document"]:hover {
    background-color: #dfdedb;
    }
    label[for="ipv_document"] {
    cursor: pointer;
    transition: 400ms ease;
    }
    span.cap_btn.large_btn {
    display: inline-flex;
    }
    .stepArea {
    max-width: 800px;
    flex: 0 0 100%;
    }
    .scrollbarStep {
    background: 0 0;
    overflow-x: hidden;
    height: calc(100vh - 125px);
    position: relative;
    padding: 0px;
    }
    .upload-section {
    max-width: 900px;
    flex: 0 0 100%;
    }
    .idenCopy-upload input.idNumber {
    display: none;
    }
    .inbit.enable {
    position: relative;
    }
    .inbit input#Proof_of_Identity {
    width: 100%;
    height: 100%;
    }
    .cap_btn {
    border: none !important;
    padding: 6px 20px;
    border-radius: 5px;
    margin: 0px 5px;
    }
    .scanInfo p {
    position: relative;
    padding-left: 26px;
    margin-left: 20px;
    }
    .scanInfo p svg.feather {
    fill: yellow;
    position: absolute;
    left: 0;
    top: 1px;
    }
    .sorImh img.sucess {
    margin-bottom: 30px;
    }
    .upload-btn-wrapper.idenCopy-upload {
    height: 100%;
    border: 1px solid var(--bordercolor);
    text-align: center;
    padding: 0;
    border-radius: 5px;
    }
    .customTabs-acc {
    background: var(--bodybg);
    }
    .upload-btn-wrapper input[type="file"] {
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
    bottom: 0;
    right: 0;
    cursor: pointer;
    border: 2px solid transparent;
    width: 100%;
    }
 </style>


// WEBPACK FOOTER //
// src/components/fxView/registerSteps/step5-new.vue